<template lang="html">
    <div class="motor">

        <PageTitle
            :text="pageTitle"
            :breadcrumb="pageTitle"
            :parent="{
                text: 'Mon site',
                path: '/site'
        }">
        </PageTitle>

        <div class="layout-width padding" v-if="userSite">

            <div style="padding-bottom: 20px">
                <p>{{ pageDescription }}</p>
            </div>

            <div
                class="padding shadow"
                style="padding-top:40px; margin-bottom:20px;">
                <el-form
                    ref="formMotor"
                    :model="form"
                    :rules="rules"
                    label-width="200px">

                    <el-form-item
                        label="Nom du moteur"
                        prop="name">
                        <el-col :span="22">
                            <el-input
                                v-model="form.name"
                                @keyup.enter.native="save">
                            </el-input>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Dénomination du moteur">
                            </FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Puissance (kW)"
                        prop="detail_pn"
                    >
                        <el-col
                            :xs="22"
                            :sm="8">
                            <el-input-number
                                v-model.number="form.detail_pn"
                                :min="0"
                                style="width:100%">
                            </el-input-number>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp text="Puissance nominale"></FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Application"
                        prop="application_uid">
                        <el-col :span="12">
                            <el-select
                                v-model="form.application_uid"
                                placeholder="Sélectioner une application"
                                style="width:100%">
                                <el-option
                                    v-for="o in orderedMotorApplication"
                                    :key="o.uid"
                                    :label="o.label"
                                    :value="o.uid">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Type de machine entrainée">
                            </FormHelp>
                        </el-col>
                    </el-form-item>


                    <el-form-item
                        v-if="displayApplicationOther"
                        label="Autre application">
                        <el-col :span="22">
                            <el-input
                                v-model="form.application_other">
                            </el-input>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Technologie"
                        prop="technology_uid">
                        <el-col :span="12">
                            <el-select
                                v-model="form.technology_uid"
                                placeholder="Type du moteur"
                                style="width:100%">
                                <el-option
                                    v-for="o in orderedMotorTechnology"
                                    :key="o.uid"
                                    :label="o.label"
                                    :value="o.uid">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Type du moteur">
                            </FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Besoin"
                        prop="need_uid">
                        <el-col :span="12">
                            <el-select
                                v-model="form.need_uid"
                                placeholder="Sélectioner un besoin"
                                style="width:100%">
                                <el-option
                                    v-for="o in motorNeed"
                                    :key="o.uid"
                                    :label="o.label"
                                    :value="o.uid">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Indiquer la variation de la charge au cours du temps">
                            </FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Régulation"
                        prop="detail_regulation_uid">
                        <el-col :span="12">
                            <el-select
                                v-model="form.detail_regulation_uid"
                                placeholder="Sélectioner une régulation"
                                style="width:100%">
                                <el-option
                                    v-for="o in orderedMotorRegulationDetail"
                                    :key="o.uid"
                                    :label="o.label"
                                    :value="o.uid">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Idem viveco">
                            </FormHelp>
                        </el-col>
                    </el-form-item>

                    <!-- <el-form-item
                        label="Un (Volt)"
                        prop="detail_un"
                    >
                        <el-col
                            :xs="22"
                            :sm="8">
                            <el-input-number
                                v-model="form.detail_un"
                                :min="0"
                                style="width:100%">
                            </el-input-number>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp text="Tension nominale plaquée"></FormHelp>
                        </el-col>
                    </el-form-item> -->

                    <el-form-item
                        label="Un (Volt)"
                        prop="detail_un"
                    >
                        <el-col :span="12">
                            <el-select
                                v-model="form.detail_un"
                                placeholder="Sélectioner un nombre de Volt"
                                style="width:100%">
                                <el-option
                                    v-for="(volt, index) in detailVolts"
                                    :key="index"
                                    :label="volt.label"
                                    :value="volt.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp text="Tension nominale plaquée"></FormHelp>
                        </el-col>

                    </el-form-item>

                    <!-- <el-form-item
                        label="Vitesse de rotation"
                        prop="detail_speed">
                        <el-col
                            class="large-text"
                            :xs="22"
                            :sm="8">
                            <el-input-number
                                v-model.number="form.detail_speed"
                                :min="0"
                                style="width:100%">
                            </el-input-number>
                        </el-col>
                        <el-col
                            :span="2">
                            <FormHelp text="Vitesse de rotation nominale plaquée"></FormHelp>
                        </el-col>
                    </el-form-item> -->
                    <el-form-item
                        label="Vitesse de rotation"
                        prop="detail_speed"
                    >
                        <el-col :span="12">
                            <el-select
                                v-model="form.detail_speed"
                                placeholder="Sélectioner un nombre de vitesse de rotation"
                                style="width:100%">
                                <el-option
                                    v-for="(speed, index) in detailSpeed"
                                    :key="index"
                                    :label="speed.label"
                                    :value="speed.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp text="Tension nominale plaquée"></FormHelp>
                        </el-col>

                    </el-form-item>


                    <el-form-item
                        label="Durée journalière"
                        prop="usage_uid">
                        <el-col :span="12">
                            <el-select
                                v-model="form.usage_uid"
                                placeholder="Sélectioner une durée"
                                style="width:100%">
                                <el-option
                                    v-for="o in orderedMotorUsage"
                                    :key="o.uid"
                                    :label="o.label"
                                    :value="o.uid">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Durée approximative de fonctionnement par jour en heure">
                            </FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Age (ans)"
                        prop="age_uid">
                        <el-col :span="12">
                            <el-select
                                v-model="form.age_uid"
                                placeholder="Sélectioner une tranche"
                                style="width:100%">
                                <el-option
                                    v-for="o in orderedMotorAge"
                                    :key="o.uid"
                                    :label="o.label"
                                    :value="o.uid">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Age approximatif du moteur">
                            </FormHelp>
                        </el-col>
                    </el-form-item>


                    <el-form-item
                        label="Commentaire"
                        prop="comment">
                        <el-col :span="24">
                            <el-input v-model="form.comment" type="textarea" :autosize="{minRows: 3}"></el-input>
                        </el-col>
                    </el-form-item>

                    <el-form-item>
                        <el-button
                            type="primary"
                            icon="el-icon-check"
                            @click="save">
                            Enregistrer
                        </el-button>
                        <el-button
                            icon="el-icon-close"
                            @click="$router.go(-1)">
                            Annuler
                        </el-button>
                    </el-form-item>

                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/partials/ui/PageTitle';
import FormHelp from '@/components/partials/ui/FormHelp';
import schwartz from 'schwartz';
export default {
    name: 'Motor',
    components: {
        PageTitle,
        FormHelp
    },
    data () {
        return {
            form: {
                name: '',
                application_uid: '',
                application_other: '',
                technology_uid: '',
                need_uid: '',
                detail_regulation_uid: '',
                usage_uid: '',
                detail_pn: null,
                detail_un: null,
                detail_speed: null,
                age_uid: '',
                score: 0,
                trained_machine: {
                    pn_me: '',
                    efficiency: '',
                    flow: '',
                    pressure: '',
                    flow_unit: '',
                    pressure_unit: '',
                },
                selected: false,
                comment: '',
            },
            rules: {
                name: [
                    { required: true, message: 'Le nom du moteur est un champs obligatoire', trigger: 'blur' }
                ],
                application_uid: [
                    { required: true, message: 'L\'application est un champs obligatoire', trigger: 'change' }
                ],
                technology_uid: [
                    { required: true, message: 'La technologie est un champs obligatoire', trigger: 'change' }
                ],
                need_uid: [
                    { required: true, message: 'La description est un champs obligatoire', trigger: 'change' }
                ],
                detail_regulation_uid: [
                    { required: true, message: 'La régulation est un champs obligatoire', trigger: 'change' }
                ],
                detail_pn: [
                    { required: true, message: 'La puissance est un champs obligatoire', trigger: 'change' }
                ],
                detail_un: [
                    { required: true, message: 'La tension est un champs obligatoire', trigger: 'change' }
                ],
                detail_speed: [
                    { required: true, message: 'La vitesse de rotation est un champs obligatoire', trigger: 'change' }
                ],
                usage_uid: [
                    { required: true, message: 'L\'utilisation est un champs obligatoire', trigger: 'change' }
                ],
                age_uid: [
                    { required: true, message: 'L\'age est un champs obligatoire', trigger: 'change' }
                ],
            },
            scopedRegulations: {
                unknown: [
                    'drawing_beforehand_with_registers',
                    'drawing_afterwards_with_registers',
                    'drawing_beforehand_with_valves',
                    'electronic_speed_variation',
                    'no_adjustment',
                    'blades_with_self_adjusting_interval',
                    'drawing_afterwards',
                    'no_adjustment',
                    'by_pass',
                    'throttle_valve',
                    'coupler',
                    'all_or_none',
                    'unknown'
                ],
                centrifugal_ventilation: [
                    'drawing_beforehand_with_registers',
                    'drawing_afterwards_with_registers',
                    'drawing_beforehand_with_valves',
                    'electronic_speed_variation',
                    'no_adjustment',
                    'unknown'
                ],
                axial_ventilation: [
                    'blades_with_self_adjusting_interval',
                    'drawing_afterwards',
                    'electronic_speed_variation',
                    'no_adjustment',
                    'unknown'
                ],
                motor: [
                    'no_adjustment',
                    'unknown'
                ],
                pumping: [
                    'by_pass',
                    'throttle_valve',
                    'coupler',
                    'all_or_none',
                    'electronic_speed_variation',
                    'no_adjustment',
                    'unknown'
                ]
            },
        };
    },
    computed: {
        ...mapGetters([
            'currentSite',
            'currentUser',
            'motorByUid',

            'motorApplication',
            'motorTechnology',
            'motorNeed',
            'motorRegulationDetail',
            'motorUsage',
            'motorAge',

            'motorApplicationByUid',
            'motorTechnologyByUid',
            'motorNeedByUid',
            'motorRegulationDetailByUid',
            'motorUsageByUid',
            'motorAgeByUid',
        ]),
        userSite () {
            if (this.currentSite){
                return this.currentSite
            }
            this.$router.push({name: 'Home'})
        },
        casingtypes() {
            return [
                {
                    label: '--------',
                    value: ''
                },
                {
                    label: 'Aluminium',
                    value: 'aluminium'
                },
                {
                    label: 'Fonte',
                    value: 'cast_iron'
                },
                {
                    label: 'ATEX',
                    value: 'atex'
                },
            ];
        },
        detailVolts() {
            return [
                {
                    label: '230V',
                    value: 230
                },
                {
                    label: '400V',
                    value: 400
                },
                {
                    label: '> 400V',
                    value: -1
                },
                {
                    label: 'Ne sait pas',
                    value: -2
                },
            ];

            // Pour les valeurs se référer à la fonction getScore de getters.js
        },
        detailSpeed () {
            return [
                {
                    label: '1400 à 1500',
                    value: 1450
                },
                {
                    label: '2900 à 3000',
                    value: 2950
                },
                {
                    label: 'Autre',
                    value: -1
                },
                {
                    label: 'Ne sait pas',
                    value: -2
                },
            ];

            // Pour les valeurs se référer à la fonction getScore de getters.js
        },
        allowedMotorRegulationDetail (){
            let motorApplication = this.motorApplicationByUid(this.form.application_uid);
            if (!motorApplication){
                return []
            }
            let regulations = this.motorRegulationDetail.filter((mrd) => {
                if (this.scopedRegulations[motorApplication.verbose_label]) {
                    return this.scopedRegulations[motorApplication.verbose_label].includes(mrd.verbose_label);
                }
            });

            if (!regulations.length) {
                return this.motorRegulationDetail;
            }
            return regulations;
        },

        orderedMotorApplication() {
            return schwartz(this.motorApplication, (application) => application.display_order);
        },
        orderedMotorTechnology() {
            return schwartz(this.motorTechnology, (techno) => techno.display_order);
        },
        orderedMotorUsage() {
            return schwartz(this.motorUsage, (usage) => usage.display_order);
        },
        orderedMotorAge() {
            return schwartz(this.motorAge, (age) => age.display_order);

        },
        orderedMotorRegulationDetail () {
            return schwartz(this.allowedMotorRegulationDetail, (regulation) => regulation.display_order);
        },
        currentMotor () {
            return this.$route.params.motorUid
                ? this.motorByUid(this.$route.params.motorUid)
                : null;
        },
        pageTitle () {
            return this.currentMotor
                ? 'Moteur ' + this.currentMotor.name
                : this.form.name
                    ? 'Moteur ' + this.form.name
                    : 'Nouveau moteur';
        },
        pageDescription () {
            return this.currentMotor
                ? 'Modifier les informations relatives au moteur ' + this.currentMotor.name
                : 'Remplir ce formulaire pour ajouter un moteur à la liste des moteurs présents sur mon site.';
        },
        displayApplicationOther () {
            const applicationValue = this.form.application_uid ? this.motorApplicationByUid(this.form.application_uid) : null;
            // eslint-disable-next-line
            return applicationValue && applicationValue.label === 'Autre' ? true : false;
        }
    },
    created () {
        if (this.currentMotor) {
            this.form = Object.assign({}, this.form, this.currentMotor);
        }
    },
    methods: {
        save () {
            this.$refs.formMotor.validate( valid => {
                if (valid) {
                    // calculate score
                    this.form.score = this.$store.getters.getScore(this);
                    if (this.form.score <= 0){
                        this.form.selected = false;
                    }
                    const method = this.currentMotor
                        ? 'patchItem' : 'createItem';
                    const item = this.currentMotor
                        ? Object.assign({
                            uid: this.currentMotor.uid,
                            url: this.currentMotor.url
                        }, this.form)
                        : this.form;

                    item.site_uid = this.userSite.uid;

                    delete item.measures_file;
                    // save in concrete
                    this.$store.dispatch(method, {
                        item,
                        model: 'motor',
                        url: 'motor/'
                    // eslint-disable-next-line
                    }).then(res => {
                        this.$notify({
                            title: 'Enregistré',
                            message: 'Moteur enregistré avec succès',
                            type: 'success'
                        });
                        this.$router.push({ name: 'Home' });
                    }).catch(err => {
                        // console.log(err);
                        this.$notify({
                            title: 'Erreur',
                            message: err.message,
                            type: 'error'
                        });
                    });
                } else {
                    this.$notify({
                        title: 'Erreur',
                        message: 'Merci de vérifiez que les champs sont bien renseignés',
                        type: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/page/Motors/Motor.vue